export default [
    { lat: 48.279667, lng: 16.368714 },
    { lat: 48.257627, lng: 16.385007 },
    { lat: 48.230678, lng: 16.413386 },
    { lat: 48.207567, lng: 16.448073 },
    { lat: 48.179539, lng: 16.491168 },
    { lat: 48.159560, lng: 16.525855 },
    { lat: 48.153951, lng: 16.532162 },
    { lat: 48.145886, lng: 16.544775 },
    { lat: 48.138171, lng: 16.573680 },
    { lat: 48.153951, lng: 16.572104 },
    { lat: 48.159560, lng: 16.573155 },
    { lat: 48.161664, lng: 16.550030 },
    { lat: 48.171479, lng: 16.545826 },
    { lat: 48.173581, lng: 16.533213 },
    { lat: 48.191102, lng: 16.537943 },
    { lat: 48.200211, lng: 16.533213 },
    { lat: 48.238729, lng: 16.550556 },
    { lat: 48.244329, lng: 16.537417 },
    { lat: 48.262176, lng: 16.543724 },
    { lat: 48.261476, lng: 16.531636 },
    { lat: 48.267424, lng: 16.513242 },
    { lat: 48.273721, lng: 16.503782 },
    { lat: 48.285262, lng: 16.511139 },
    { lat: 48.292956, lng: 16.482760 },
    { lat: 48.280016, lng: 16.484862 },
    { lat: 48.273371, lng: 16.481708 },
    { lat: 48.290858, lng: 16.437562 },
    { lat: 48.316028, lng: 16.435985 },
    { lat: 48.321620, lng: 16.419168 },
    { lat: 48.315679, lng: 16.403401 },
    { lat: 48.318475, lng: 16.388685 },
    { lat: 48.301696, lng: 16.386583 },
    { lat: 48.288759, lng: 16.380277 },
    { lat: 48.280016, lng: 16.368189 },
]
